module.exports = __webpack_public_path__ + "img/recolumn_example2.eeb4b6a3.png";